'use client';

import { AppToaster } from '@/components/ui/toast';
import { AuthProvider } from "@/context/AuthContext";
import { CookieConsent } from '@/components/cookies/cookie_consent';
import { ReactNode } from 'react';
import { ActivityTracker } from '@/components/authentication/activity_tracker';
import { ThemeProvider } from '@/components/general/theme_provider';
import { SidebarProvider } from '@/components/ui/custom-sidebar';
import { SidebarMenuProvider } from '@/components/general/SidebarMenuProvider';
import { SearchProvider } from '@/components/search/SearchContext'
import type { SessionUser } from "@/lib/types";

export function Providers({
  children,
  initialUser,
}: {
  children: ReactNode;
  initialUser: SessionUser | null;
}) {

  return (
      <AuthProvider initialUser={initialUser}>
        <ActivityTracker>
          <ThemeProvider
            attribute="class"
            defaultTheme="system"
            enableSystem
            disableTransitionOnChange
          >
            <SearchProvider>
              <SidebarProvider>
                <SidebarMenuProvider>
                  {children}
                </SidebarMenuProvider>
              </SidebarProvider>
            </SearchProvider>
          </ThemeProvider>
        </ActivityTracker>
        {/* The app's ONE Toaster. Its position and the toast card's shape are both defined in
            components/ui/toast; nothing else should mount a Toaster. */}
        <AppToaster />
      </AuthProvider>
  );
}
